import React, { forwardRef, ReactNode } from 'react';
import {
  FormLabel as ChakraFormLabel,
  FormLabelProps,
  useStyleConfig,
} from '@chakra-ui/react';

interface Props extends Omit<FormLabelProps, `css`> {
  children: ReactNode;
  htmlFor: string;
  variant?: 'proRikApp'
}

export const FormLabel = forwardRef<HTMLLabelElement, Props>(
  ({ children, htmlFor, variant, ...props }, ref): JSX.Element => {
    const styles = useStyleConfig(`FormLabel`, {variant});

    return (
      <ChakraFormLabel htmlFor={htmlFor} ref={ref} sx={styles} {...props}>
        {children}
      </ChakraFormLabel>
    );
  }
);
export type { Props as FormLabelProps };
